import { mapActions, mapGetters } from "vuex";

export default {
    name: "ProfileCosmobasePage",
    props: {},
    emits: [],
    components: {},
    setup() {},
    data() {
        return {}
    },
    async created() {
      await Promise.all([
        this.getWebinars()
      ])
    },
    mounted() {},
    watch: {},
    computed: {
      ...mapGetters({
        webinarList: "cosmobase/webinarList"
      })
    },
    methods: {
      ...mapActions({
        getWebinars: "cosmobase/GET_WEBINARS"
      })
    }
}
